<template>
    <span
        :class="getObjectStatus.class"
        class="font-medium mr-2 dark:bg-blue-900 dark:text-blue-300 shadow-lg">
        {{ getObjectStatus.label || '' }}
    </span>
</template>

<script lang="ts" setup>
const props = defineProps({
  module: {
    type: String,
    required: true
  },
  status: {
    type: [String, Number],
    required: true
  },
  size: {
    type: String,
    default: 'default'
  }
})

const { module, status, size } = toRefs(props)

const getStatusModule: { [key: string]: any } = {
  vehicles: {
    1: { label: $t('labels.readyShip'), class: 'bg-success-100 text-success-800' },
    '-1': { label: $t('labels.vehicleModule.notReady'), class: 'bg-error-100 text-error-800' }
  },
  driver: {
    0: { label: $t('labels.notReadyYet'), class: 'bg-yellow-100 text-yelow-800' },
    1: { label: $t('labels.conditionallyReady'), class: 'bg-blue-100 text-blue-800' },
    2: { label: $t('labels.ready'), class: 'bg-green-100 text-green-800' }
  },
  order: {
    0: { label: 'pending', class: 'bg-yellow-100 text-yelow-800' },
    1: { label: 'active', class: 'bg-blue-100 text-blue-800' },
    2: { label: 'complete', class: 'bg-green-100 text-green-800' }
  },
  quote: {
    0: { label: $t('labels.init'), class: 'bg-yellow-100 text-yelow-800' },
    1: { label: $t('labels.send'), class: 'bg-blue-100 text-blue-800' },
    2: { label: $t('labels.orderCreated'), class: 'bg-green-100 text-green-800' },
    3: { label: $t('labels.cancel'), class: 'bg-error-100 text-error-800' }
  },
  quoteRequest: {
    0: { label: $t('labels.init'), class: 'bg-yellow-100 text-yelow-800' },
    1: { label: $t('labels.quoteCreated'), class: 'bg-green-100 text-green-800' },
    3: { label: $t('labels.cancel'), class: 'bg-error-100 text-error-800' }
  }
}

const getObjectStatus = computed(() => {
  const classT = getStatusModule[module.value][String(status.value)] || {}
  if (size.value === 'default') {
    classT.class += ' text-xs px-2.5 py-0.5 rounded'
  }
  if (size.value === 'large') {
    classT.class += ' text-[18px] font-medium mr-2 p-[8px] select-none rounded-xl'
  }

  return classT
})
</script>

<style scoped></style>
